
import Breadcrumb from '../../components/Breadcrumb.vue';
import BlockImgsRandom from '../../components/BlockImgsRandom.vue';
import { MarkPage } from '~/graphql/queries/Mark';

export default {
  layout: 'MainLayout',
  auth: false,
  data() {
    return {
      markPage: {},
    };
  },
  apollo: {
    markPage: {
      query: MarkPage,
      variables() {
        return {
          lang: this.$i18n.locale,
        };
      },
    },
  },
  computed: {
    breadcrumbLinks() {
      return [
        {
          link: '/',
          text: this.$t('Home'),
        },
        {
          text: this.markPage.data ? this.markPage.data.attributes.title : '',
        },
      ];
    },
  },

  mounted() {
    if (process.client) {
      window.scrollTo(0, 0);
    }
  },
  components: { Breadcrumb, BlockImgsRandom },
};
